export const config = {
	"pwa": "https://pwa.congreet.com",
	"deeplink": "https://congreet.app.link/app-open",
	"availableLangs": [
		"de",
		"en",
		"fr",
		"es"
	],
	"hideSidebarPublicPages": false,
	"publicPagesLang": false,
	"hideLogout": false,
	"hideSettingsPasswordReset": false,
	"atsAnonymous": true,
	"noIframeRediret": "",
	"showInstallPrompt": true,
	"showCredentialWallet": false,
	"hideRatingInMembers": false,
	"sameSiteAssets": false,
	"maxAppointmentBlockSize": 60
}